import { render, staticRenderFns } from "./HistoryReportStudent.vue?vue&type=template&id=6051a04d&scoped=true"
import script from "./HistoryReportStudent.vue?vue&type=script&lang=js"
export * from "./HistoryReportStudent.vue?vue&type=script&lang=js"
import style0 from "./HistoryReportStudent.vue?vue&type=style&index=0&id=6051a04d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6051a04d",
  null
  
)

export default component.exports